export type LangCode = 'en' | 'hi' | 'ta' | 'te' | 'kn' | 'mr' | 'bn' | 'gu';

export interface Language {
  code: LangCode;
  native: string;      // displayed in language picker
  latin: string;       // fallback display when font missing
  full: boolean;       // true = all namespaces; false = only auth (skeleton)
}

export const LANG_LIST: Language[] = [
  { code: 'en', native: 'English',  latin: 'English',  full: true },
  { code: 'hi', native: 'हिन्दी',     latin: 'Hindi',    full: true },
  { code: 'ta', native: 'தமிழ்',      latin: 'Tamil',    full: false },
  { code: 'te', native: 'తెలుగు',     latin: 'Telugu',   full: false },
  { code: 'kn', native: 'ಕನ್ನಡ',      latin: 'Kannada',  full: false },
  { code: 'mr', native: 'मराठी',      latin: 'Marathi',  full: false },
  { code: 'bn', native: 'বাংলা',      latin: 'Bengali',  full: false },
  { code: 'gu', native: 'ગુજરાતી',    latin: 'Gujarati', full: false },
];

export const LANG_STORAGE_KEY = 'fu_driver_lang';
